import { Typography } from "@material-ui/core";
import { FC, useEffect, useState } from "react";
import Loader from "../../Loader";
import { fetchClientData } from "../utils";

const ClientPhoneNumber: FC<any> = (props) => {
  const [clientPhoneNumber, setClientPhoneNumber] = useState<any>(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    (async function () {
      setLoading(true);
      const data = await fetchClientData(props);
      setClientPhoneNumber(data.phoneNumber ?? "N/A");
      setLoading(false);
    })();
  }, []);

  return (
    <Loader loading={loading}>
      <Typography variant="body2">{clientPhoneNumber}</Typography>
    </Loader>
  );
};

export default ClientPhoneNumber;
